<template>
  <div class="message-wrapper">
    <div class="message error">
      <p class="content">
        <slot></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message'
}
</script>

<style lang="scss">
.message-wrapper {
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
